import Vue from 'vue';
import report from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import ElementUI from 'element-ui';
import format from '@/mixin/format';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/app.less';

import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);

// 全局组件
import registerComponent from '@/global';

Vue.use(ElementUI);

Vue.use(registerComponent);

Vue.mixin(format);

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

//- 设置cookie
Vue.prototype.$setCookie = (name, value) => {
  document.cookie = name + '=' + escape(value) + '; path=/' + ';';
};

// 删除cookie
Vue.prototype.$delCookie = name => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = this.$getCookie(name);
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
};

// 删除cookie
Vue.prototype.$getCookie = name => {
  var c_start, c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(name + '=');
    if (c_start != -1) {
      c_start = c_start + name.length + 1;
      c_end = document.cookie.indexOf(';', c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return '';
};

Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }

  return fmt;
};

new Vue({
  store,
  router,
  render: h => h(report)
}).$mount('#report');
